import { IoMdClose } from '@react-icons/all-files/io/IoMdClose';
import { motion } from 'framer-motion';
import type { FC } from 'react';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { submitEnquiryRequest } from '../../../../graphql/mutation';
import Modal from '../../../shared/modal';
import ModalWrapper from '../../../shared/modal/modal-wrapper';

const EnquireProduct: FC<{ product: string }> = ({ product }) => {
  const [show, setShow] = useState(false);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [companyName, setCompanyName] = useState('');

  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(): Promise<void> {
    try {
      if (!firstName.trim() || !lastName.trim()) {
        toast.error('Name cannot be empty');
        return;
      }

      if (!email.trim()) {
        toast.error('Email cannot be empty');
        return;
      }

      if (!phoneNumber.trim()) {
        toast.error('Phone number cannot be empty');
        return;
      }

      if (!companyName.trim()) {
        toast.error('Message cannot be empty');
        return;
      }

      const postData = {
        operationName: 'EnquirySubmit',
        variables: {
          data: {
            FirstName: firstName,
            LastName: lastName,
            CompanyName: companyName,
            product,
            Email: email,
            Phone: phoneNumber,
          },
        },
        query: submitEnquiryRequest,
      };
      setLoading(true);

      const response = await fetch(`${process.env.GATSBY_API_URL}/graphql`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${process.env.GATSBY_API_SECRET}`,
        },
        body: JSON.stringify(postData),
      });

      if (!response.ok) {
        toast.error('Something went wrong');
        setLoading(false);
        return;
      }

      await response.json();
      setLoading(false);
      toast.success('Enquiry request submitted successfully');
    } catch (error) {
      toast.error('Something went wrong');
      setLoading(false);
    }
  }

  return (
    <div className="border border-solid border-[#DA2801] rounded-md p-px transition-smooth hover:-translate-y-1">
      <button
        className="px-6 py-2 flex space-x-3 items-center"
        onClick={() => {
          setShow(true);
        }}
        type="button"
      >
        <span className="uppercase font-bold text-base text-[#DA2801]">
          Enquiry
        </span>
      </button>

      <Modal setShowModal={setShow} showModal={show}>
        <ModalWrapper>
          <motion.div
            animate={{ y: 0 }}
            className="relative rounded-md shadow-2xl  
            m-auto bg-gray-50 md:p-10 p-6 max-w-3xl w-full border"
            transition={{ duration: 0.5, ease: 'easeOut' }}
          >
            <div className="flex justify-end">
              <button
                className="transition-smooth hover:scale-105"
                onClick={() => {
                  setShow(false);
                }}
                type="button"
              >
                <IoMdClose className="text-2xl " />
              </button>
            </div>
            <h2 className="text-2xl font-medium">Enquire Now</h2>
            <p className="text-gray-600 font-light my-3">
              Please provide your details below and we will get back to you
              shortly.
            </p>

            <form
              onSubmit={(ev) => {
                ev.preventDefault();
                void handleSubmit();
              }}
            >
              <div className="grid md:grid-cols-2 gap-6 mt-6">
                <input
                  className="outline-none bg-transparent w-full py-2 px-3 border-b
                border-gray-500"
                  onChange={(ev) => {
                    setFirstName(ev.target.value);
                  }}
                  placeholder="First Name"
                  type="text"
                  value={firstName}
                />
                <input
                  className="outline-none bg-transparent w-full py-2 px-3 border-b
                border-gray-500 appearance-none"
                  onChange={(ev) => {
                    setLastName(ev.target.value);
                  }}
                  placeholder="Last Name"
                  type="text"
                  value={lastName}
                />
                <input
                  className="outline-none bg-transparent w-full py-2 px-3 border-b
                border-gray-500 appearance-none"
                  onChange={(ev) => {
                    setCompanyName(ev.target.value);
                  }}
                  placeholder="Company Name"
                  type="text"
                  value={companyName}
                />
                {/* 
                <input
                  className="outline-none bg-transparent w-full py-2 px-3 border-b
                border-gray-500 appearance-none"
                  onChange={(ev) => {
                    setProductId(ev.target.value);
                  }}
                  placeholder="Product"
                  type="text"
                  value={productId}
                /> */}

                <input
                  className="outline-none bg-transparent w-full py-2 px-3 border-b
                border-gray-500"
                  onChange={(ev) => {
                    setEmail(ev.target.value);
                  }}
                  placeholder="Email Address"
                  type="email"
                  value={email}
                />
                <input
                  className="outline-none bg-transparent w-full py-2 px-3 border-b
                border-gray-500"
                  onChange={(ev) => {
                    setPhoneNumber(ev.target.value);
                  }}
                  placeholder="Phone Number"
                  type="number"
                  value={phoneNumber}
                />
              </div>
              <button
                className="border whitespace-nowrap border-gray-950 py-2 px-8 mt-8
              font-medium tracking-wide transition-smooth bg-gray-900 text-gray-50
              uppercase"
                disabled={loading}
                type="submit"
              >
                {loading ? 'Please wait' : 'Submit'}
              </button>
            </form>
          </motion.div>
        </ModalWrapper>
      </Modal>
    </div>
  );
};

export default EnquireProduct;
